// extracted by mini-css-extract-plugin
export default {"dropzone":"styles_dropzone__8RZzn","active":"styles_active__6w5xO","container":"styles_container__FIyKn","btn":"styles_btn__hmmxc"};